
export class MySpaceConstants{
    static UserProfileTopBarTitle: string = "User profile";
    static UserProfileTabName:string = "User Profile";
    static TrainingProfileTabName: string = "Training Profile"; 
    public static readonly ExportFileNameForTrainingPlan="Training Plan Export_PUID_DATE.xlsx" ;

    public static Severity_Err: string = "Error";
    public static Get_Training_Plan_Review_Failure: string = "Failed to fetch Training Plan Review History";
    
    //Information Message 
    public static readonly ShowAll_InformationIconMessage : string = "By default only the Pending and Locked Training Requirements are displayed. Check this check box to display the other Training Requirements."
    public static readonly TrainingPlanReview_Complete_Status_AcknowledgementMessage : string = "I hereby declare that I have reviewed this Training Plan accurately as per the applicable procedure."
    public static readonly TrainingPlanReview_Heading : string = "Review Training Plan";
    public static readonly TrainingPlanreview_ValidationMessage : string ='Please enter a Review Comment';

    //Attachment File Size
    public static readonly Attachment_File_Max_Size:number=100;

    //Training Quiz Answer Audit
    public static readonly UTC_TimeFormat : string = "(UTC)";
    public static readonly TrainingRequirementType_Document : string = "Document";
    public static readonly TrainingRequirementType_Course : string = "Course";
    public static readonly TrainingQuizAnswerModal_InstructionToClose = 'Press Esc to close the modal';


    // Training Occurrence Session Details
    public static readonly StatusName_Scheduled: string = 'Scheduled';
    public static readonly StatusClassName_Scheduled: string = 'scheduled';
    public static readonly StatusName_Completed : string = 'Completed';
    public static readonly StatusClassName_Completed : string = 'completed';
    public static readonly StatusName_Cancelled: string = 'Cancelled';
    public static readonly StatusClassName_Cancelled: string = 'cancelled';

    public static readonly FormatName_Open: string = 'Open';
    public static readonly FormatClassName_Open: string = 'open';
    public static readonly FormatName_Closed: string = 'Closed';
    public static readonly FormatClassName_Closed: string = 'closed';

    public static readonly Virtual_MeetingURL_Text: string = "Virtual Meeting URL";
    public static readonly Trainers_Field_Constant: string ="trainers"

}
